import React from 'react';

import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';

import PlagiarismIcon from '@mui/icons-material/Plagiarism';

import useDialogStatus from '../../hooks/useDialogStatus';
import EntityOverlay from './EntityOverlay';

const QuickView = ({ caseId }: { caseId: string }) => {
  const { open, openDialog, closeDialog } = useDialogStatus();

  return (
    <>
      <EntityOverlay defaultEntries="transactions" open={open} closeDialog={closeDialog} caseId={caseId} />
      <Tooltip title="Quick view">
        <IconButton color="primary" onClick={openDialog}>
          <PlagiarismIcon />
        </IconButton>
      </Tooltip>
    </>
  );
};

export default QuickView;
